import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import AOS from 'aos';
import {
  FaCode, FaMobileAlt, FaRobot, FaCloud, FaBuilding, FaPalette,
  FaNetworkWired, FaShieldAlt, FaArrowRight
} from 'react-icons/fa';
import servicesData from '../data/services.json';
import './Solutions.css';

const ICON_MAP = {
  FaCode: <FaCode />, FaMobileAlt: <FaMobileAlt />, FaRobot: <FaRobot />,
  FaCloud: <FaCloud />, FaBuilding: <FaBuilding />, FaPalette: <FaPalette />,
  FaNetworkWired: <FaNetworkWired />, FaShieldAlt: <FaShieldAlt />,
};

const COLOR_MAP = [
  '#1e40af', '#0891b2', '#7c3aed', '#059669',
  '#d97706', '#dc2626', '#0891b2', '#1e40af',
];

const PROCESS = [
  { num: '01', title: 'Discovery & Planning', desc: 'We analyze your requirements, define scope, and create a detailed technical roadmap.' },
  { num: '02', title: 'Design & Prototype', desc: 'UI/UX wireframes and clickable prototypes for your approval before development begins.' },
  { num: '03', title: 'Development', desc: 'Agile sprints with daily standups, code reviews, and continuous integration.' },
  { num: '04', title: 'Testing & QA', desc: 'Rigorous testing — unit, integration, performance, and user acceptance testing.' },
  { num: '05', title: 'Deployment', desc: 'CI/CD pipeline deployment with zero-downtime and full monitoring setup.' },
  { num: '06', title: 'Support & Scale', desc: '24/7 post-launch support, SLA-backed maintenance, and continuous feature evolution.' },
];

const Solutions = () => {
  useEffect(() => { AOS.init({ duration: 900, once: true, offset: 80 }); }, []);

  return (
    <div className="solutions-page">

      <section className="page-hero">
        <div className="page-hero-overlay" />
        <Container>
          <div className="page-hero-content" data-aos="fade-up">
            <div className="breadcrumb-vk">
              <Link to="/">Home</Link> / <span>Solutions</span>
            </div>
            <h1 className="page-hero-title">
              AI-Powered Software<br />
              <span>Solutions & Services</span>
            </h1>
            <p className="page-hero-desc">
              From custom web &amp; mobile applications to enterprise ERP, AI automation, and cloud architecture — we deliver technology that transforms your business.
            </p>
          </div>
        </Container>
      </section>

      {/* Services Grid */}
      <section className="section-py" style={{ background: 'var(--color-bg)' }}>
        <Container>
          <div className="section-header text-center" data-aos="fade-up">
            <span className="section-badge">What We Build</span>
            <h2 className="section-title">
              Comprehensive <span>Technology Services</span>
            </h2>
            <p className="section-subtitle">
              End-to-end software development, AI solutions, and enterprise systems for forward-thinking organizations.
            </p>
          </div>
          <Row className="g-4">
            {servicesData.map((service, i) => (
              <Col lg={3} md={6} key={service.id} data-aos="fade-up" data-aos-delay={i * 80}>
                <div className="service-card-vk">
                  <div className="service-card-top" style={{ background: `${COLOR_MAP[i]}08` }}>
                    <div className="service-icon-vk" style={{ background: `${COLOR_MAP[i]}15`, color: COLOR_MAP[i] }}>
                      {ICON_MAP[service.icon]}
                    </div>
                    <span className="service-category-tag">{service.category}</span>
                  </div>
                  <div className="service-card-body">
                    <h3 className="service-name">{service.title}</h3>
                    <p className="service-desc">{service.description}</p>
                    <Link to="/contact" className="service-learn-more" style={{ color: COLOR_MAP[i] }}>
                      Get a Quote <FaArrowRight />
                    </Link>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Process */}
      <section className="section-py" style={{ background: 'var(--color-bg-alt)' }}>
        <Container>
          <div className="section-header text-center" data-aos="fade-up">
            <span className="section-badge">How We Work</span>
            <h2 className="section-title">Our <span>Development Process</span></h2>
            <p className="section-subtitle">A battle-tested agile process that delivers on time, every time.</p>
          </div>
          <div className="process-grid">
            {PROCESS.map((step, i) => (
              <div key={i} className="process-step" data-aos="fade-up" data-aos-delay={i * 80}>
                <div className="process-num">{step.num}</div>
                <h4 className="process-title">{step.title}</h4>
                <p className="process-desc">{step.desc}</p>
              </div>
            ))}
          </div>
        </Container>
      </section>

      {/* Tech Stack */}
      <section className="section-py" style={{ background: 'var(--color-bg)' }}>
        <Container>
          <div className="section-header text-center" data-aos="fade-up">
            <span className="section-badge">Technology Stack</span>
            <h2 className="section-title">Built with <span>Modern Technologies</span></h2>
          </div>
          <div className="tech-stack-grid" data-aos="fade-up">
            {['React', 'Angular', 'Node.js', '.NET Core', 'Python', 'Flutter', 'React Native',
              'PostgreSQL', 'MongoDB', 'Redis', 'AWS', 'Azure', 'Docker', 'Kubernetes',
              'TensorFlow', 'OpenAI'].map((tech, i) => (
              <div key={i} className="tech-badge">{tech}</div>
            ))}
          </div>
        </Container>
      </section>

      {/* CTA */}
      <section className="cta-section">
        <Container className="text-center" data-aos="zoom-in">
          <h2 className="cta-title">Ready to Build <span>Something Great?</span></h2>
          <p className="cta-desc">Tell us about your project and we'll craft the perfect solution.</p>
          <div className="cta-actions">
            <Link to="/contact" className="btn-primary-vk">Get Free Consultation <FaArrowRight /></Link>
          </div>
        </Container>
      </section>

    </div>
  );
};

export default Solutions;
